<template>
    <div>
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="上传图片" prop="attachments">
                        <preview-upload
                            v-model="info.attachments"
                            multiple
                            :format="imgSuffix"
                            :maxNumber="5"
                        ></preview-upload>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>

<script>
import config from "@/config";
import PreviewUpload from "_c/preview-upload";

import {  contractUpdateAttach } from "@/api/contract";

export default {
    name: "c-upload-contract",
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                id: this.id,
                attachments: "", // 附件
                ver: this.ver, // 版本号
            },
            imgSuffix: config.upload.imgSuffix,
        };
    },
    props: {
        id: {
            type: [String, Number],
            default: "",
        },
        ver: {
            type: [String, Number],
            default: "",
        }
    },
    components: { PreviewUpload },
    computed: {
        ruleValidate() {
            return {};
        },
    },
    mounted() {
        var $info = this.$refs.info;

        // 按钮配置
        var btns = [{ type: "default", text: "取消", name: "cancel" }];

        if (this.$can("update")) {
            btns.unshift({
                type: "primary",
                name: "confirm",
                text: "确定",
            });
        }
        this.$modal.updateBtns(btns);

        // 确定
        this.$modal.onBtnClick("confirm", (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info);

                    return contractUpdateAttach(formData);
                })
                .then((res) => {
                    this.$Message.success(this.$t("tips.add.success"));
                })
                .catch((err) => {
                    options.closeModal = false;
                })
                .finally(() => {
                    next();
                });
        });
    },
};
</script>

<style></style>
